import React from 'react';
import PropTypes from 'prop-types';
import { Box, Icon, Typography } from '@popmenu/common-ui';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getUserEntryPointFromParam } from '~/utils/userEntryPoint';
import { SubmitGroup, TextFieldGroup } from '../../admin/shared/forms/BasicForm';
import BasicForm from '../../admin/shared/forms/BasicForm/BasicForm';
import MagicLinkSVG from '../../assets/svg/magic_link.svg';
import sendUserAutoLoginEmailMutation from '../../libs/gql/mutations/users/sendUserAutoLoginEmailMutation.gql';
import { notBlankValidator } from '../../utils/forms';
import { AH } from '../../consumer/shared/AccessibleHeading';

const useMessages = () => {
  const { formatMessage } = useIntl();

  return {
    emailRequestMessage: magicLink => formatMessage({ defaultMessage: "If you have an account with us, you'll receive a {magicLink} in your email to sign back into your My.Pop account." }, { magicLink }),
    emailSent: formatMessage({ defaultMessage: 'Email Sent!' }),
    emailSentDescription: formatMessage({ defaultMessage: 'You will receive an email if you have an account with us. Check your email for a magic link to sign back into your account in the next few minutes.' }),
    magicLink: formatMessage({ defaultMessage: 'magic link' }),
  };
};

const MagicLinkForm = ({ onCompleted, sentMagicLink }) => {
  const messages = useMessages();
  const vipData = useSelector(state => state.modals.vipData);
  const { isReviewPath, isPopPath } = vipData;

  const userEntryPoint = getUserEntryPointFromParam(isReviewPath, isPopPath);

  return (
    <BasicForm mutate={{
      mutation: sendUserAutoLoginEmailMutation,
      onCompleted,
      toVariables: values => ({
        ...values,
        restaurantId: null,
        userEntryPoint,
      }),
    }}
    >
      {sentMagicLink ? (
        <React.Fragment>
          <Box textAlign="center">
            <Icon icon={MagicLinkSVG} style={{ height: '160px', width: '160px' }} aria-label="Magic Link" />
          </Box>
          <AH typography variant="h4" gutterBottom>
            {messages.emailSent}
          </AH>
          <Typography gutterBottom>
            {messages.emailSentDescription}
          </Typography>
          <br />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Typography>
            {messages.emailRequestMessage(
              <strong>
                {messages.magicLink}
              </strong>,
            )}
          </Typography>
          <br />
          <TextFieldGroup
            aria-label="Email Address"
            data-cy="email_magic_link"
            field="email"
            title="Email"
            type="email"
            validate={notBlankValidator}
          />
          <SubmitGroup
            data-cy="magic_link_submit"
            block
            ButtonProps={{ textTransform: 'capitalize' }}
            title="Send magic link"
          />
        </React.Fragment>
      )}
    </BasicForm>
  );
};

MagicLinkForm.propTypes = {
  onCompleted: PropTypes.func.isRequired,
  sentMagicLink: PropTypes.bool.isRequired,
};

export default MagicLinkForm;
